let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kgAik")).then(() => parcelRequire('5qYor'));